var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIlustraDocumento(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 140.85,
    height: 167.8,
    viewBox: "0 0 140.85 167.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ret\\xE2ngulo_8058",
    x: 0,
    y: 0,
    width: 140.85,
    height: 167.8,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ret\\xE2ngulo_7990",
    "data-name": "Ret\\xE2ngulo 7990",
    d: "M8.613,0H72.25a8.613,8.613,0,0,1,8.613,8.613V44.84a8.612,8.612,0,0,1-8.612,8.612H8.613A8.613,8.613,0,0,1,0,44.839V8.613A8.613,8.613,0,0,1,8.613,0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14261",
    "data-name": "Caminho 14261",
    d: "M394.555,292.381a6.185,6.185,0,1,0,6.185-6.185,6.185,6.185,0,0,0-6.185,6.185",
    transform: "translate(-394.555 -286.196)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_7992",
    "data-name": "Ret\\xE2ngulo 7992",
    width: 22.832,
    height: 25.464,
    rx: 3.762,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8056",
    "data-name": "Ret\\xE2ngulo 8056",
    width: 17.366,
    height: 23.593,
    fill: "#0f1824"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14348",
    "data-name": "Caminho 14348",
    d: "M12.439,28.4A10.558,10.558,0,1,0,23,17.843,10.557,10.557,0,0,0,12.439,28.4",
    transform: "translate(-12.439 -17.843)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ilustra-documento",
    transform: "translate(30 27)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -30, -27)",
    filter: "url(#Ret\\xE2ngulo_8058)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8058-2",
    "data-name": "Ret\\xE2ngulo 8058",
    width: 80.85,
    height: 107.8,
    rx: 4,
    transform: "translate(30 27)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14578",
    "data-name": "Grupo 14578"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8055",
    "data-name": "Ret\\xE2ngulo 8055",
    width: 80.85,
    height: 107.8,
    rx: 4,
    transform: "translate(0.111 0.06)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14570",
    "data-name": "Grupo 14570",
    transform: "translate(0 54.474)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14560",
    "data-name": "Grupo 14560",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14224",
    "data-name": "Caminho 14224",
    d: "M159.169,402.474l1.559,3.536,3.842-.418-2.283,3.118,2.283,3.118-3.842-.418-1.559,3.536-1.559-3.536-3.842.418,2.283-3.118-2.283-3.118,3.842.418Z",
    transform: "translate(-159.168 -355.259)",
    fill: "none",
    stroke: "#cbe2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14225",
    "data-name": "Caminho 14225",
    d: "M159.116,403.417l-6.449-.7-2.617,5.935-2.617-5.935-6.449.7,3.832-5.234-3.832-5.234,6.449.7,2.617-5.935,2.617,5.935,6.449-.7-3.832,5.234Z",
    transform: "translate(-150.05 -344.731)",
    fill: "none",
    stroke: "#cbe2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14226",
    "data-name": "Caminho 14226",
    d: "M153.664,395l-9.056-.985-3.675,8.335-3.675-8.335L128.2,395l5.381-7.35L128.2,380.3l9.055.985,3.675-8.335,3.675,8.335,9.056-.985-5.381,7.35Z",
    transform: "translate(-140.932 -334.202)",
    fill: "none",
    stroke: "#cbe2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14227",
    "data-name": "Caminho 14227",
    d: "M148.21,386.591l-11.662-1.268-4.733,10.734-4.733-10.734-11.662,1.268,6.93-9.466-6.93-9.466,11.662,1.268,4.733-10.734,4.733,10.734,11.662-1.268-6.93,9.466Z",
    transform: "translate(-131.814 -323.673)",
    fill: "none",
    stroke: "#cbe2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14228",
    "data-name": "Caminho 14228",
    d: "M142.757,378.179l-14.269-1.552L122.7,389.761l-5.791-13.133-14.269,1.552,8.478-11.582-8.478-11.582,14.269,1.552,5.791-13.134,5.791,13.134,14.269-1.552L134.279,366.6Z",
    transform: "translate(-122.696 -313.145)",
    fill: "none",
    stroke: "#cbe2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14229",
    "data-name": "Caminho 14229",
    d: "M137.3,369.767l-16.876-1.835-6.849,15.533-6.849-15.533-16.876,1.835,10.027-13.7-10.027-13.7,16.876,1.835,6.849-15.533,6.849,15.533,16.876-1.835-10.027,13.7Z",
    transform: "translate(-113.578 -302.617)",
    fill: "none",
    stroke: "#cbe2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14230",
    "data-name": "Caminho 14230",
    d: "M131.851,361.354l-19.483-2.119-7.907,17.932-7.907-17.932-19.483,2.119L88.648,345.54,77.071,329.727l19.483,2.119,7.907-17.932,7.907,17.932,19.483-2.119L120.275,345.54Z",
    transform: "translate(-104.46 -292.088)",
    fill: "none",
    stroke: "#cbe2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14231",
    "data-name": "Caminho 14231",
    d: "M126.4,352.941l-22.09-2.4-8.965,20.331-8.965-20.331-22.09,2.4,13.125-17.93L64.288,317.082l22.09,2.4,8.965-20.331,8.965,20.331,22.09-2.4-13.125,17.929Z",
    transform: "translate(-95.342 -281.56)",
    fill: "none",
    stroke: "#cbe2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14232",
    "data-name": "Caminho 14232",
    d: "M120.945,344.529l-24.7-2.686L86.225,364.574,76.2,341.843l-24.7,2.686L66.18,324.484,51.506,304.438l24.7,2.686,10.023-22.731,10.023,22.731,24.7-2.686-14.674,20.045Z",
    transform: "translate(-86.224 -271.032)",
    fill: "none",
    stroke: "#cbe2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14233",
    "data-name": "Caminho 14233",
    d: "M115.492,336.116l-27.3-2.969-11.081,25.13-11.08-25.13-27.3,2.969,16.223-22.161L38.723,291.794l27.3,2.969,11.08-25.13,11.081,25.13,27.3-2.969L99.269,313.955Z",
    transform: "translate(-77.107 -260.503)",
    fill: "none",
    stroke: "#cbe2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14234",
    "data-name": "Caminho 14234",
    d: "M110.039,327.7l-29.911-3.253L67.99,351.981l-12.139-27.53L25.94,327.7l17.772-24.277L25.94,279.149,55.851,282.4l12.139-27.53L80.128,282.4l29.911-3.253L92.267,303.427Z",
    transform: "translate(-67.988 -249.975)",
    fill: "none",
    stroke: "#cbe2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14235",
    "data-name": "Caminho 14235",
    d: "M104.586,319.291l-32.517-3.536-13.2,29.929-13.2-29.929-32.517,3.536L32.479,292.9,13.158,266.505l32.517,3.536,13.2-29.929,13.2,29.929,32.517-3.536L85.265,292.9Z",
    transform: "translate(-58.871 -239.446)",
    fill: "none",
    stroke: "#cbe2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14236",
    "data-name": "Caminho 14236",
    d: "M49.754,225.352,64.008,257.68l35.124-3.819L78.263,282.37l20.87,28.509-35.124-3.819L49.754,339.388,35.5,307.059.375,310.879l20.87-28.509L.375,253.861,35.5,257.68Z",
    transform: "translate(-49.753 -228.918)",
    fill: "none",
    stroke: "#cbe2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14237",
    "data-name": "Caminho 14237",
    d: "M418.021,170.026l-9.055-.985-3.675,8.335-3.675-8.335-9.055.985,5.38-7.35-5.38-7.35,9.055.985,3.675-8.335,3.675,8.335,9.055-.985-5.381,7.35Z",
    transform: "translate(-329.497 -173.726)",
    fill: "none",
    stroke: "#cbe2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14238",
    "data-name": "Caminho 14238",
    d: "M412.567,161.614,400.9,160.346l-4.733,10.734-4.733-10.734-11.663,1.268,6.93-9.466-6.93-9.466,11.663,1.268,4.733-10.734L400.9,143.95l11.662-1.268-6.93,9.466Z",
    transform: "translate(-320.379 -163.197)",
    fill: "none",
    stroke: "#cbe2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14239",
    "data-name": "Caminho 14239",
    d: "M407.115,153.2l-14.269-1.552-5.791,13.134-5.791-13.134L366.994,153.2l8.478-11.582-8.478-11.582,14.269,1.552,5.791-13.133,5.791,13.133,14.269-1.552-8.478,11.582Z",
    transform: "translate(-311.261 -152.669)",
    fill: "none",
    stroke: "#cbe2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14240",
    "data-name": "Caminho 14240",
    d: "M401.661,144.789l-16.876-1.835-6.849,15.533-6.849-15.533-16.876,1.835,10.027-13.7-10.027-13.7,16.876,1.835,6.849-15.533,6.849,15.533,16.876-1.835-10.027,13.7Z",
    transform: "translate(-302.143 -142.141)",
    fill: "none",
    stroke: "#cbe2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14241",
    "data-name": "Caminho 14241",
    d: "M396.208,136.376l-19.483-2.119-7.907,17.932-7.907-17.932-19.483,2.119L353,120.563l-11.576-15.814,19.483,2.119,7.907-17.932,7.907,17.932,19.483-2.119-11.577,15.814Z",
    transform: "translate(-293.026 -131.612)",
    fill: "none",
    stroke: "#cbe2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14242",
    "data-name": "Caminho 14242",
    d: "M390.755,127.964l-22.09-2.4L359.7,145.894l-8.965-20.331-22.09,2.4,13.126-17.929L328.645,92.105l22.09,2.4L359.7,74.176l8.965,20.331,22.09-2.4L377.63,110.035Z",
    transform: "translate(-283.907 -121.084)",
    fill: "none",
    stroke: "#cbe2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14243",
    "data-name": "Caminho 14243",
    d: "M385.3,119.552l-24.7-2.686L350.582,139.6,340.56,116.866l-24.7,2.686,14.674-20.045L315.863,79.461l24.7,2.686,10.023-22.731,10.023,22.731,24.7-2.686L370.628,99.506Z",
    transform: "translate(-274.79 -110.556)",
    fill: "none",
    stroke: "#cbe2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14244",
    "data-name": "Caminho 14244",
    d: "M379.849,111.139l-27.3-2.969L341.465,133.3l-11.08-25.13-27.3,2.969L319.3,88.978,303.081,66.816l27.3,2.969,11.08-25.131,11.081,25.131,27.3-2.969L363.626,88.978Z",
    transform: "translate(-265.672 -100.027)",
    fill: "none",
    stroke: "#cbe2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14245",
    "data-name": "Caminho 14245",
    d: "M374.4,102.726l-29.911-3.253L332.347,127l-12.139-27.53L290.3,102.726,308.07,78.449,290.3,54.172l29.911,3.253L332.347,29.9l12.138,27.53L374.4,54.172,356.624,78.449Z",
    transform: "translate(-256.554 -89.499)",
    fill: "none",
    stroke: "#cbe2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14246",
    "data-name": "Caminho 14246",
    d: "M368.943,94.314l-32.517-3.536-13.2,29.929-13.2-29.929-32.518,3.536,19.321-26.393L277.515,41.528l32.518,3.536,13.2-29.929,13.2,29.929,32.517-3.536L349.622,67.921Z",
    transform: "translate(-247.436 -78.97)",
    fill: "none",
    stroke: "#cbe2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14247",
    "data-name": "Caminho 14247",
    d: "M314.111.375,328.365,32.7l35.124-3.819L342.62,57.392,363.49,85.9l-35.124-3.819L314.111,114.41,299.856,82.082,264.732,85.9,285.6,57.392l-20.87-28.509L299.856,32.7Z",
    transform: "translate(-238.318 -68.442)",
    fill: "none",
    stroke: "#cbe2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14571",
    "data-name": "Grupo 14571",
    transform: "translate(63.771 74.275)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14568",
    "data-name": "Grupo 14568",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14251",
    "data-name": "Caminho 14251",
    d: "M406.924,292.381a6.185,6.185,0,1,1-6.185-6.185,6.185,6.185,0,0,1,6.185,6.185",
    transform: "translate(-394.554 -286.196)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14252",
    "data-name": "Caminho 14252",
    d: "M413.493,303.324l.306.693.753-.082-.448.611.448.611-.753-.082-.306.693-.306-.693-.753.082.448-.611-.448-.611.753.082Z",
    transform: "translate(-407.309 -298.413)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14253",
    "data-name": "Caminho 14253",
    d: "M412.949,302.685l-1.52-.165-.617,1.4-.617-1.4-1.52.165.9-1.233-.9-1.233,1.52.165.617-1.4.617,1.4,1.52-.165-.9,1.233Z",
    transform: "translate(-404.628 -295.318)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14254",
    "data-name": "Caminho 14254",
    d: "M411.345,300.21l-2.286-.249-.928,2.1-.928-2.1-2.286.249,1.358-1.855-1.358-1.856,2.286.249.928-2.1.928,2.1,2.286-.249-1.358,1.856Z",
    transform: "translate(-401.946 -292.222)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14255",
    "data-name": "Caminho 14255",
    d: "M409.742,297.737l-3.053-.332-1.239,2.81-1.239-2.81-3.053.332,1.814-2.478-1.814-2.478,3.053.332,1.239-2.81,1.239,2.81,3.053-.332-1.814,2.478Z",
    transform: "translate(-399.265 -289.126)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14256",
    "data-name": "Caminho 14256",
    d: "M408.139,295.263l-3.819-.415-1.55,3.515-1.55-3.515-3.819.415,2.269-3.1-2.269-3.1,3.819.415,1.55-3.515,1.55,3.515,3.819-.415-2.269,3.1Z",
    transform: "translate(-396.585 -286.03)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14257",
    "data-name": "Caminho 14257",
    d: "M406.535,292.79l-4.586-.5-1.861,4.221-1.861-4.221-4.586.5,2.725-3.722-2.725-3.722,4.586.5,1.861-4.221,1.861,4.221,4.586-.5-2.725,3.722Z",
    transform: "translate(-393.903 -282.935)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14258",
    "data-name": "Caminho 14258",
    d: "M404.932,290.316l-5.353-.582-2.172,4.926-2.172-4.926-5.352.582,3.18-4.344-3.18-4.344,5.352.582,2.172-4.926,2.172,4.926,5.353-.582-3.18,4.344Z",
    transform: "translate(-391.222 -279.838)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14259",
    "data-name": "Caminho 14259",
    d: "M403.328,287.842l-6.119-.665-2.483,5.632-2.483-5.632-6.119.665,3.636-4.967-3.636-4.966,6.119.665,2.483-5.632,2.483,5.632,6.119-.665-3.636,4.966Z",
    transform: "translate(-388.541 -276.743)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14260",
    "data-name": "Caminho 14260",
    d: "M392.045,268.6l2.794,6.337,6.885-.749-4.091,5.589,4.091,5.588-6.885-.749-2.794,6.337-2.794-6.337-6.886.749,4.091-5.588-4.091-5.589,6.886.749Z",
    transform: "translate(-385.86 -273.647)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("text", {
    id: "ISSUE",
    transform: "translate(66.995 95.167)",
    fill: "#1a262e",
    fontSize: 1,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ISSUE")), /*#__PURE__*/React.createElement("text", {
    id: "DD_MM_YYYY",
    "data-name": "DD/MM/YYYY",
    transform: "translate(66.742 96.282)",
    fill: "#1a262e",
    fontSize: 1,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DD/MM/"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.002em"
  }, "Y"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.003em"
  }, "Y"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.002em"
  }, "Y"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "Y")), /*#__PURE__*/React.createElement("text", {
    id: "VALID",
    transform: "translate(66.995 98.982)",
    fill: "#1a262e",
    fontSize: 1,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    letterSpacing: "-0.057em"
  }, "V"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "ALID")), /*#__PURE__*/React.createElement("text", {
    id: "DD_MM_YYYY-2",
    "data-name": "DD/MM/YYYY",
    transform: "translate(66.742 100.098)",
    fill: "#1a262e",
    fontSize: 1,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DD/MM/"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.002em"
  }, "Y"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.003em"
  }, "Y"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.002em"
  }, "Y"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "Y")), /*#__PURE__*/React.createElement("text", {
    id: "SURNAME",
    transform: "translate(31.097 76.314)",
    fill: "#1a262e",
    fontSize: 1,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SURN"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "-0.004em"
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "ME")), /*#__PURE__*/React.createElement("text", {
    id: "LOREM",
    transform: "translate(30.725 77.646)",
    fill: "#1a262e",
    fontSize: 1,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    letterSpacing: "-0.038em"
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "OREM")), /*#__PURE__*/React.createElement("text", {
    id: "SEX",
    transform: "translate(47.106 76.314)",
    fill: "#1a262e",
    fontSize: 1,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SEX")), /*#__PURE__*/React.createElement("text", {
    id: "M",
    transform: "translate(47.106 77.646)",
    fill: "#1a262e",
    fontSize: 1,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "M")), /*#__PURE__*/React.createElement("text", {
    id: "NAME",
    transform: "translate(31.097 82.492)",
    fill: "#1a262e",
    fontSize: 1,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "N"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "-0.004em"
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "ME")), /*#__PURE__*/React.createElement("text", {
    id: "IPSUM",
    transform: "translate(30.725 83.825)",
    fill: "#1a262e",
    fontSize: 1,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "IPSUM")), /*#__PURE__*/React.createElement("text", {
    id: "DATE_OF_BIRTH",
    "data-name": "DATE OF BIRTH",
    transform: "translate(31.097 88.671)",
    fill: "#1a262e",
    fontSize: 1,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    letterSpacing: "-0.013em"
  }, "D"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "-0.077em"
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "TE OF BI"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.008em"
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "TH")), /*#__PURE__*/React.createElement("text", {
    id: "DD_MM_YYYY-3",
    "data-name": "DD/MM/YYYY",
    transform: "translate(30.725 90.004)",
    fill: "#1a262e",
    fontSize: 1,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DD/MM/"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.003em"
  }, "Y"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.002em"
  }, "Y"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.003em"
  }, "Y"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "Y")), /*#__PURE__*/React.createElement("text", {
    id: "NATIONALITY",
    transform: "translate(31.097 94.848)",
    fill: "#1a262e",
    fontSize: 1,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "N"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "-0.077em"
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "TIONALI"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.028em"
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "Y")), /*#__PURE__*/React.createElement("text", {
    id: "LOREM_IPSUM",
    "data-name": "LOREM IPSUM",
    transform: "translate(30.725 96.183)",
    fill: "#1a262e",
    fontSize: 1,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    letterSpacing: "-0.038em"
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "OREM IPSUM")), /*#__PURE__*/React.createElement("text", {
    id: "CLASS:_A",
    "data-name": "CLASS: A",
    transform: "translate(64.029 89.991)",
    fill: "#1a262e",
    fontSize: 1,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CLASS: A")), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14561",
    "data-name": "Grupo 14561",
    transform: "translate(0.137 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14560-2",
    "data-name": "Grupo 14560",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14224-2",
    "data-name": "Caminho 14224",
    d: "M159.169,402.474l1.559,3.536,3.842-.418-2.283,3.118,2.283,3.118-3.842-.418-1.559,3.536-1.559-3.536-3.842.418,2.283-3.118-2.283-3.118,3.842.418Z",
    transform: "translate(-159.168 -355.259)",
    fill: "none",
    stroke: "#cbe2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14225-2",
    "data-name": "Caminho 14225",
    d: "M159.116,403.417l-6.449-.7-2.617,5.935-2.617-5.935-6.449.7,3.832-5.234-3.832-5.234,6.449.7,2.617-5.935,2.617,5.935,6.449-.7-3.832,5.234Z",
    transform: "translate(-150.05 -344.731)",
    fill: "none",
    stroke: "#cbe2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14226-2",
    "data-name": "Caminho 14226",
    d: "M153.664,395l-9.056-.985-3.675,8.335-3.675-8.335L128.2,395l5.381-7.35L128.2,380.3l9.055.985,3.675-8.335,3.675,8.335,9.056-.985-5.381,7.35Z",
    transform: "translate(-140.932 -334.202)",
    fill: "none",
    stroke: "#cbe2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14227-2",
    "data-name": "Caminho 14227",
    d: "M148.21,386.591l-11.662-1.268-4.733,10.734-4.733-10.734-11.662,1.268,6.93-9.466-6.93-9.466,11.662,1.268,4.733-10.734,4.733,10.734,11.662-1.268-6.93,9.466Z",
    transform: "translate(-131.814 -323.673)",
    fill: "none",
    stroke: "#cbe2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14228-2",
    "data-name": "Caminho 14228",
    d: "M142.757,378.179l-14.269-1.552L122.7,389.761l-5.791-13.133-14.269,1.552,8.478-11.582-8.478-11.582,14.269,1.552,5.791-13.134,5.791,13.134,14.269-1.552L134.279,366.6Z",
    transform: "translate(-122.696 -313.145)",
    fill: "none",
    stroke: "#cbe2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14229-2",
    "data-name": "Caminho 14229",
    d: "M137.3,369.767l-16.876-1.835-6.849,15.533-6.849-15.533-16.876,1.835,10.027-13.7-10.027-13.7,16.876,1.835,6.849-15.533,6.849,15.533,16.876-1.835-10.027,13.7Z",
    transform: "translate(-113.578 -302.617)",
    fill: "none",
    stroke: "#cbe2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14230-2",
    "data-name": "Caminho 14230",
    d: "M131.851,361.354l-19.483-2.119-7.907,17.932-7.907-17.932-19.483,2.119L88.648,345.54,77.071,329.727l19.483,2.119,7.907-17.932,7.907,17.932,19.483-2.119L120.275,345.54Z",
    transform: "translate(-104.46 -292.088)",
    fill: "none",
    stroke: "#cbe2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14231-2",
    "data-name": "Caminho 14231",
    d: "M126.4,352.941l-22.09-2.4-8.965,20.331-8.965-20.331-22.09,2.4,13.125-17.93L64.288,317.082l22.09,2.4,8.965-20.331,8.965,20.331,22.09-2.4-13.125,17.929Z",
    transform: "translate(-95.342 -281.56)",
    fill: "none",
    stroke: "#cbe2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14232-2",
    "data-name": "Caminho 14232",
    d: "M120.945,344.529l-24.7-2.686L86.225,364.574,76.2,341.843l-24.7,2.686L66.18,324.484,51.506,304.438l24.7,2.686,10.023-22.731,10.023,22.731,24.7-2.686-14.674,20.045Z",
    transform: "translate(-86.224 -271.032)",
    fill: "none",
    stroke: "#cbe2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14233-2",
    "data-name": "Caminho 14233",
    d: "M115.492,336.116l-27.3-2.969-11.081,25.13-11.08-25.13-27.3,2.969,16.223-22.161L38.723,291.794l27.3,2.969,11.08-25.13,11.081,25.13,27.3-2.969L99.269,313.955Z",
    transform: "translate(-77.107 -260.503)",
    fill: "none",
    stroke: "#cbe2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14234-2",
    "data-name": "Caminho 14234",
    d: "M110.039,327.7l-29.911-3.253L67.99,351.981l-12.139-27.53L25.94,327.7l17.772-24.277L25.94,279.149,55.851,282.4l12.139-27.53L80.128,282.4l29.911-3.253L92.267,303.427Z",
    transform: "translate(-67.988 -249.975)",
    fill: "none",
    stroke: "#cbe2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14235-2",
    "data-name": "Caminho 14235",
    d: "M104.586,319.291l-32.517-3.536-13.2,29.929-13.2-29.929-32.517,3.536L32.479,292.9,13.158,266.505l32.517,3.536,13.2-29.929,13.2,29.929,32.517-3.536L85.265,292.9Z",
    transform: "translate(-58.871 -239.446)",
    fill: "none",
    stroke: "#cbe2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14236-2",
    "data-name": "Caminho 14236",
    d: "M49.754,225.352,64.008,257.68l35.124-3.819L78.263,282.37l20.87,28.509-35.124-3.819L49.754,339.388,35.5,307.059.375,310.879l20.87-28.509L.375,253.861,35.5,257.68Z",
    transform: "translate(-49.753 -228.918)",
    fill: "none",
    stroke: "#cbe2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14237-2",
    "data-name": "Caminho 14237",
    d: "M418.021,170.026l-9.055-.985-3.675,8.335-3.675-8.335-9.055.985,5.38-7.35-5.38-7.35,9.055.985,3.675-8.335,3.675,8.335,9.055-.985-5.381,7.35Z",
    transform: "translate(-329.497 -173.726)",
    fill: "none",
    stroke: "#cbe2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14238-2",
    "data-name": "Caminho 14238",
    d: "M412.567,161.614,400.9,160.346l-4.733,10.734-4.733-10.734-11.663,1.268,6.93-9.466-6.93-9.466,11.663,1.268,4.733-10.734L400.9,143.95l11.662-1.268-6.93,9.466Z",
    transform: "translate(-320.379 -163.197)",
    fill: "none",
    stroke: "#cbe2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14239-2",
    "data-name": "Caminho 14239",
    d: "M407.115,153.2l-14.269-1.552-5.791,13.134-5.791-13.134L366.994,153.2l8.478-11.582-8.478-11.582,14.269,1.552,5.791-13.133,5.791,13.133,14.269-1.552-8.478,11.582Z",
    transform: "translate(-311.261 -152.669)",
    fill: "none",
    stroke: "#cbe2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14240-2",
    "data-name": "Caminho 14240",
    d: "M401.661,144.789l-16.876-1.835-6.849,15.533-6.849-15.533-16.876,1.835,10.027-13.7-10.027-13.7,16.876,1.835,6.849-15.533,6.849,15.533,16.876-1.835-10.027,13.7Z",
    transform: "translate(-302.143 -142.141)",
    fill: "none",
    stroke: "#cbe2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14241-2",
    "data-name": "Caminho 14241",
    d: "M396.208,136.376l-19.483-2.119-7.907,17.932-7.907-17.932-19.483,2.119L353,120.563l-11.576-15.814,19.483,2.119,7.907-17.932,7.907,17.932,19.483-2.119-11.577,15.814Z",
    transform: "translate(-293.026 -131.612)",
    fill: "none",
    stroke: "#cbe2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14242-2",
    "data-name": "Caminho 14242",
    d: "M390.755,127.964l-22.09-2.4L359.7,145.894l-8.965-20.331-22.09,2.4,13.126-17.929L328.645,92.105l22.09,2.4L359.7,74.176l8.965,20.331,22.09-2.4L377.63,110.035Z",
    transform: "translate(-283.907 -121.084)",
    fill: "none",
    stroke: "#cbe2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14243-2",
    "data-name": "Caminho 14243",
    d: "M385.3,119.552l-24.7-2.686L350.582,139.6,340.56,116.866l-24.7,2.686,14.674-20.045L315.863,79.461l24.7,2.686,10.023-22.731,10.023,22.731,24.7-2.686L370.628,99.506Z",
    transform: "translate(-274.79 -110.556)",
    fill: "none",
    stroke: "#cbe2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14244-2",
    "data-name": "Caminho 14244",
    d: "M379.849,111.139l-27.3-2.969L341.465,133.3l-11.08-25.13-27.3,2.969L319.3,88.978,303.081,66.816l27.3,2.969,11.08-25.131,11.081,25.131,27.3-2.969L363.626,88.978Z",
    transform: "translate(-265.672 -100.027)",
    fill: "none",
    stroke: "#cbe2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14245-2",
    "data-name": "Caminho 14245",
    d: "M374.4,102.726l-29.911-3.253L332.347,127l-12.139-27.53L290.3,102.726,308.07,78.449,290.3,54.172l29.911,3.253L332.347,29.9l12.138,27.53L374.4,54.172,356.624,78.449Z",
    transform: "translate(-256.554 -89.499)",
    fill: "none",
    stroke: "#cbe2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14246-2",
    "data-name": "Caminho 14246",
    d: "M368.943,94.314l-32.517-3.536-13.2,29.929-13.2-29.929-32.518,3.536,19.321-26.393L277.515,41.528l32.518,3.536,13.2-29.929,13.2,29.929,32.517-3.536L349.622,67.921Z",
    transform: "translate(-247.436 -78.97)",
    fill: "none",
    stroke: "#cbe2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14247-2",
    "data-name": "Caminho 14247",
    d: "M314.111.375,328.365,32.7l35.124-3.819L342.62,57.392,363.49,85.9l-35.124-3.819L314.111,114.41,299.856,82.082,264.732,85.9,285.6,57.392l-20.87-28.509L299.856,32.7Z",
    transform: "translate(-238.318 -68.442)",
    fill: "none",
    stroke: "#cbe2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14248",
    "data-name": "Caminho 14248",
    d: "M209.8,306.415H189.13a1.079,1.079,0,0,1-1.079-1.079V282.03a1.079,1.079,0,0,1,1.079-1.079H209.8a1.079,1.079,0,0,1,1.079,1.079v23.306a1.079,1.079,0,0,1-1.079,1.079",
    transform: "translate(-183.485 -268.576)",
    fill: "#9eb4c4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14565",
    "data-name": "Grupo 14565",
    transform: "translate(4.567 12.375)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14564",
    "data-name": "Grupo 14564",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14249",
    "data-name": "Caminho 14249",
    d: "M195.11,305.105a1.536,1.536,0,0,0,.483-.314,2.573,2.573,0,0,0,.814-1.912v-.105a16.472,16.472,0,0,1-2.421-.52v-5.035a2.517,2.517,0,0,1-.454-.922.843.843,0,0,1,.454-.824v-2.315l.021,0c.04-5.12,6.331-5.181,7.191-3.889,1.717-.314,3.83.343,4.06,2.858h0v.005a5.56,5.56,0,0,1,0,.953v2.5a.844.844,0,0,1,.286.711,1.541,1.541,0,0,1-.286.652v5.3a17.256,17.256,0,0,1-2.744.565v.06a2.573,2.573,0,0,0,.814,1.912,1.535,1.535,0,0,0,.483.314c.663.241,5.188,1.177,7.057,2.775v4.072H188.052V307.88c1.87-1.6,6.394-2.533,7.058-2.775",
    transform: "translate(-188.052 -286.38)",
    fill: "#1a262e"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_7993",
    "data-name": "Ret\\xE2ngulo 7993",
    width: 22.832,
    height: 8.091,
    transform: "translate(4.567 41.878)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_7994",
    "data-name": "Ret\\xE2ngulo 7994",
    width: 48.883,
    height: 5.359,
    transform: "translate(29.153 43.243)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_7995",
    "data-name": "Ret\\xE2ngulo 7995",
    width: 0.762,
    height: 4.49,
    transform: "translate(29.639 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_7996",
    "data-name": "Ret\\xE2ngulo 7996",
    width: 0.381,
    height: 4.49,
    transform: "translate(30.722 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_7997",
    "data-name": "Ret\\xE2ngulo 7997",
    width: 0.381,
    height: 4.49,
    transform: "translate(31.384 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_7998",
    "data-name": "Ret\\xE2ngulo 7998",
    width: 0.381,
    height: 4.49,
    transform: "translate(34.29 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_7999",
    "data-name": "Ret\\xE2ngulo 7999",
    width: 0.381,
    height: 4.49,
    transform: "translate(35.014 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8000",
    "data-name": "Ret\\xE2ngulo 8000",
    width: 0.381,
    height: 4.49,
    transform: "translate(37.509 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8001",
    "data-name": "Ret\\xE2ngulo 8001",
    width: 0.381,
    height: 4.49,
    transform: "translate(39.464 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8002",
    "data-name": "Ret\\xE2ngulo 8002",
    width: 0.381,
    height: 4.49,
    transform: "translate(41.043 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8003",
    "data-name": "Ret\\xE2ngulo 8003",
    width: 0.604,
    height: 4.49,
    transform: "translate(36.618 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8004",
    "data-name": "Ret\\xE2ngulo 8004",
    width: 0.604,
    height: 4.49,
    transform: "translate(40.163 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8005",
    "data-name": "Ret\\xE2ngulo 8005",
    width: 0.661,
    height: 4.49,
    transform: "translate(33.35 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8006",
    "data-name": "Ret\\xE2ngulo 8006",
    width: 0.661,
    height: 4.49,
    transform: "translate(35.677 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8007",
    "data-name": "Ret\\xE2ngulo 8007",
    width: 1.038,
    height: 4.49,
    transform: "translate(32.035 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8008",
    "data-name": "Ret\\xE2ngulo 8008",
    width: 1.038,
    height: 4.49,
    transform: "translate(38.137 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8009",
    "data-name": "Ret\\xE2ngulo 8009",
    width: 0.762,
    height: 4.49,
    transform: "translate(41.731 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8010",
    "data-name": "Ret\\xE2ngulo 8010",
    width: 0.381,
    height: 4.49,
    transform: "translate(42.813 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8011",
    "data-name": "Ret\\xE2ngulo 8011",
    width: 0.381,
    height: 4.49,
    transform: "translate(43.477 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8012",
    "data-name": "Ret\\xE2ngulo 8012",
    width: 0.381,
    height: 4.49,
    transform: "translate(46.383 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8013",
    "data-name": "Ret\\xE2ngulo 8013",
    width: 0.381,
    height: 4.49,
    transform: "translate(47.106 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8014",
    "data-name": "Ret\\xE2ngulo 8014",
    width: 0.381,
    height: 4.49,
    transform: "translate(49.602 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8015",
    "data-name": "Ret\\xE2ngulo 8015",
    width: 0.381,
    height: 4.49,
    transform: "translate(51.555 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8016",
    "data-name": "Ret\\xE2ngulo 8016",
    width: 0.381,
    height: 4.49,
    transform: "translate(53.134 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8017",
    "data-name": "Ret\\xE2ngulo 8017",
    width: 0.604,
    height: 4.49,
    transform: "translate(48.71 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8018",
    "data-name": "Ret\\xE2ngulo 8018",
    width: 0.604,
    height: 4.49,
    transform: "translate(52.254 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8019",
    "data-name": "Ret\\xE2ngulo 8019",
    width: 0.661,
    height: 4.49,
    transform: "translate(45.442 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8020",
    "data-name": "Ret\\xE2ngulo 8020",
    width: 0.661,
    height: 4.49,
    transform: "translate(47.769 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8021",
    "data-name": "Ret\\xE2ngulo 8021",
    width: 1.038,
    height: 4.49,
    transform: "translate(44.128 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8022",
    "data-name": "Ret\\xE2ngulo 8022",
    width: 1.038,
    height: 4.49,
    transform: "translate(50.229 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8023",
    "data-name": "Ret\\xE2ngulo 8023",
    width: 0.762,
    height: 4.49,
    transform: "translate(53.822 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8024",
    "data-name": "Ret\\xE2ngulo 8024",
    width: 0.381,
    height: 4.49,
    transform: "translate(54.905 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8025",
    "data-name": "Ret\\xE2ngulo 8025",
    width: 0.381,
    height: 4.49,
    transform: "translate(55.568 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8026",
    "data-name": "Ret\\xE2ngulo 8026",
    width: 0.381,
    height: 4.49,
    transform: "translate(58.474 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8027",
    "data-name": "Ret\\xE2ngulo 8027",
    width: 0.381,
    height: 4.49,
    transform: "translate(59.198 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8028",
    "data-name": "Ret\\xE2ngulo 8028",
    width: 0.381,
    height: 4.49,
    transform: "translate(61.694 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8029",
    "data-name": "Ret\\xE2ngulo 8029",
    width: 0.381,
    height: 4.49,
    transform: "translate(63.648 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8030",
    "data-name": "Ret\\xE2ngulo 8030",
    width: 0.381,
    height: 4.49,
    transform: "translate(65.227 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8031",
    "data-name": "Ret\\xE2ngulo 8031",
    width: 0.604,
    height: 4.49,
    transform: "translate(60.802 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8032",
    "data-name": "Ret\\xE2ngulo 8032",
    width: 0.604,
    height: 4.49,
    transform: "translate(64.347 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8033",
    "data-name": "Ret\\xE2ngulo 8033",
    width: 0.661,
    height: 4.49,
    transform: "translate(57.534 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8034",
    "data-name": "Ret\\xE2ngulo 8034",
    width: 0.661,
    height: 4.49,
    transform: "translate(59.861 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8035",
    "data-name": "Ret\\xE2ngulo 8035",
    width: 1.038,
    height: 4.49,
    transform: "translate(56.22 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8036",
    "data-name": "Ret\\xE2ngulo 8036",
    width: 1.038,
    height: 4.49,
    transform: "translate(62.322 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8037",
    "data-name": "Ret\\xE2ngulo 8037",
    width: 0.762,
    height: 4.49,
    transform: "translate(65.914 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8038",
    "data-name": "Ret\\xE2ngulo 8038",
    width: 0.381,
    height: 4.49,
    transform: "translate(66.997 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8039",
    "data-name": "Ret\\xE2ngulo 8039",
    width: 0.381,
    height: 4.49,
    transform: "translate(67.661 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8040",
    "data-name": "Ret\\xE2ngulo 8040",
    width: 0.381,
    height: 4.49,
    transform: "translate(70.566 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8041",
    "data-name": "Ret\\xE2ngulo 8041",
    width: 0.381,
    height: 4.49,
    transform: "translate(71.29 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8042",
    "data-name": "Ret\\xE2ngulo 8042",
    width: 0.381,
    height: 4.49,
    transform: "translate(73.786 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8043",
    "data-name": "Ret\\xE2ngulo 8043",
    width: 0.381,
    height: 4.49,
    transform: "translate(75.739 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8044",
    "data-name": "Ret\\xE2ngulo 8044",
    width: 0.381,
    height: 4.49,
    transform: "translate(77.319 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8045",
    "data-name": "Ret\\xE2ngulo 8045",
    width: 0.604,
    height: 4.49,
    transform: "translate(72.893 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8046",
    "data-name": "Ret\\xE2ngulo 8046",
    width: 0.604,
    height: 4.49,
    transform: "translate(76.439 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8047",
    "data-name": "Ret\\xE2ngulo 8047",
    width: 0.661,
    height: 4.49,
    transform: "translate(69.625 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8048",
    "data-name": "Ret\\xE2ngulo 8048",
    width: 0.661,
    height: 4.49,
    transform: "translate(71.952 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8049",
    "data-name": "Ret\\xE2ngulo 8049",
    width: 1.038,
    height: 4.49,
    transform: "translate(68.312 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8050",
    "data-name": "Ret\\xE2ngulo 8050",
    width: 1.038,
    height: 4.49,
    transform: "translate(74.412 43.663)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14250",
    "data-name": "Caminho 14250",
    d: "M199.915,389.25a2.353,2.353,0,0,0,2.379.8,1.743,1.743,0,0,0,.915-.283.666.666,0,0,0,.206-.856c-.284-.412-1-.116-1.149.362a2.721,2.721,0,0,0,.177,1.468,3.1,3.1,0,0,1-.1,2.138,1.708,1.708,0,0,1-1.776.986,1.192,1.192,0,0,1-.823-1.673,1.543,1.543,0,0,1,2.072-.193c.658.4,1.146,1.043,1.816,1.423a2.788,2.788,0,0,0,4.143-2.1,1.768,1.768,0,0,0-.2-1.125,1.03,1.03,0,0,0-.971-.515,1.083,1.083,0,0,0-.674,1.522,2.063,2.063,0,0,0,1.565,1.013,3.942,3.942,0,0,0,2.544-.416,1.959,1.959,0,0,0,.988-1.049,1,1,0,0,0-.509-1.235c-.617-.222-1.267.506-1.144,1.15a1.676,1.676,0,0,0,1.41,1.2,6.453,6.453,0,0,0,1.955-.1,2.768,2.768,0,0,1,1.615.148,1.1,1.1,0,0,1,.58,1.366,1.036,1.036,0,0,1-1.688-.012,1.789,1.789,0,0,1,.093-1.916,7.778,7.778,0,0,1,1.4-1.468,3.2,3.2,0,0,0,1.081-1.679",
    transform: "translate(-191.728 -345.077)",
    fill: "none",
    stroke: "#1a262e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.633
  }), /*#__PURE__*/React.createElement("text", {
    id: "_01.234.567",
    "data-name": "01.234.567",
    transform: "translate(5.689 2.447)",
    fill: "#1a262e",
    fontSize: 1,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "01.234.567")), /*#__PURE__*/React.createElement("text", {
    id: "ISSUE-2",
    "data-name": "ISSUE",
    transform: "translate(66.995 34.77)",
    fill: "#1a262e",
    fontSize: 1,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ISSUE")), /*#__PURE__*/React.createElement("text", {
    id: "DD_MM_YYYY-4",
    "data-name": "DD/MM/YYYY",
    transform: "translate(66.742 35.885)",
    fill: "#1a262e",
    fontSize: 1,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DD/MM/"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.002em"
  }, "Y"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.003em"
  }, "Y"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.002em"
  }, "Y"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "Y")), /*#__PURE__*/React.createElement("text", {
    id: "VALID-2",
    "data-name": "VALID",
    transform: "translate(66.995 38.585)",
    fill: "#1a262e",
    fontSize: 1,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    letterSpacing: "-0.057em"
  }, "V"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "ALID")), /*#__PURE__*/React.createElement("text", {
    id: "DD_MM_YYYY-5",
    "data-name": "DD/MM/YYYY",
    transform: "translate(66.742 39.701)",
    fill: "#1a262e",
    fontSize: 1,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DD/MM/"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.002em"
  }, "Y"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.003em"
  }, "Y"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.002em"
  }, "Y"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "Y")), /*#__PURE__*/React.createElement("text", {
    id: "SURNAME-2",
    "data-name": "SURNAME",
    transform: "translate(31.098 15.917)",
    fill: "#1a262e",
    fontSize: 1,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SURN"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "-0.004em"
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "ME")), /*#__PURE__*/React.createElement("text", {
    id: "LOREM-2",
    "data-name": "LOREM",
    transform: "translate(30.726 17.249)",
    fill: "#1a262e",
    fontSize: 1,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    letterSpacing: "-0.038em"
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "OREM")), /*#__PURE__*/React.createElement("text", {
    id: "SEX-2",
    "data-name": "SEX",
    transform: "translate(47.106 15.917)",
    fill: "#1a262e",
    fontSize: 1,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SEX")), /*#__PURE__*/React.createElement("text", {
    id: "M-2",
    "data-name": "M",
    transform: "translate(47.106 17.249)",
    fill: "#1a262e",
    fontSize: 1,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "M")), /*#__PURE__*/React.createElement("text", {
    id: "NAME-2",
    "data-name": "NAME",
    transform: "translate(31.098 22.095)",
    fill: "#1a262e",
    fontSize: 1,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "N"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "-0.004em"
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "ME")), /*#__PURE__*/React.createElement("text", {
    id: "IPSUM-2",
    "data-name": "IPSUM",
    transform: "translate(30.726 23.428)",
    fill: "#1a262e",
    fontSize: 1,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "IPSUM")), /*#__PURE__*/React.createElement("text", {
    id: "DATE_OF_BIRTH-2",
    "data-name": "DATE OF BIRTH",
    transform: "translate(31.098 28.273)",
    fill: "#1a262e",
    fontSize: 1,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    letterSpacing: "-0.013em"
  }, "D"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "-0.077em"
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "TE OF BI"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.008em"
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "TH")), /*#__PURE__*/React.createElement("text", {
    id: "DD_MM_YYYY-6",
    "data-name": "DD/MM/YYYY",
    transform: "translate(30.726 29.607)",
    fill: "#1a262e",
    fontSize: 1,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DD/MM/"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.003em"
  }, "Y"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.002em"
  }, "Y"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.003em"
  }, "Y"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "Y")), /*#__PURE__*/React.createElement("text", {
    id: "NATIONALITY-2",
    "data-name": "NATIONALITY",
    transform: "translate(31.098 34.451)",
    fill: "#1a262e",
    fontSize: 1,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "N"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "-0.077em"
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "TIONALI"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.028em"
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "Y")), /*#__PURE__*/React.createElement("text", {
    id: "LOREM_IPSUM-2",
    "data-name": "LOREM IPSUM",
    transform: "translate(30.726 35.786)",
    fill: "#1a262e",
    fontSize: 1,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    letterSpacing: "-0.038em"
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "OREM IPSUM")), /*#__PURE__*/React.createElement("text", {
    id: "CLASS:_A-2",
    "data-name": "CLASS: A",
    transform: "translate(64.029 29.594)",
    fill: "#1a262e",
    fontSize: 1,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CLASS: A")), /*#__PURE__*/React.createElement("text", {
    id: "LOREM_IPSUM-3",
    "data-name": "LOREM IPSUM",
    transform: "translate(5.689 7.225)",
    fill: "#1a262e",
    fontSize: 1,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    letterSpacing: "-0.038em"
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "OREM IPSUM")), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_8057",
    "data-name": "Ret\\xE2ngulo 8057",
    width: 21.571,
    height: 32.356,
    rx: 2,
    transform: "translate(5.504 65.791)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14575",
    "data-name": "Grupo 14575",
    transform: "translate(7.606 70.173)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14574",
    "data-name": "Grupo 14574",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14337",
    "data-name": "Caminho 14337",
    d: "M6.72,16.739c1.693-1.985,2.578-4.825,2.058-6.6A1.931,1.931,0,0,0,7.508,8.72C5.657,8.158,4.6,9.846,3.255,11.983l-.189.3A8.417,8.417,0,0,1,.487,15.122a.288.288,0,0,0,.272.508,8.729,8.729,0,0,0,2.795-3.039l.19-.3c1.424-2.269,2.23-3.433,3.6-3.018A1.366,1.366,0,0,1,8.224,10.3c.4,1.368-.145,3.96-1.943,6.068a37.246,37.246,0,0,1-3.5,3.579.288.288,0,0,0,.377.436A37.848,37.848,0,0,0,6.72,16.739m-1-1.031c1.256-1.457,2.157-3.6,1.969-4.689a.925.925,0,0,0-.439-.691c-.738-.418-1.567.056-2.462,1.411-.133.2-.273.448-.421.708a9.93,9.93,0,0,1-1.523,2.167,15.955,15.955,0,0,1-1.789,1.5.288.288,0,0,0,.334.47A16.249,16.249,0,0,0,3.252,15.02a10.4,10.4,0,0,0,1.615-2.288c.149-.263.278-.489.4-.675.48-.726,1.164-1.529,1.7-1.227a.387.387,0,0,1,.155.288c.158.907-.718,2.915-1.837,4.214A41.887,41.887,0,0,1,2.093,18.6a.288.288,0,0,0,.386.428,42.5,42.5,0,0,0,3.238-3.318m-1.442-.07a13.288,13.288,0,0,0,2.043-3.12.288.288,0,0,0-.527-.235,12.942,12.942,0,0,1-1.944,2.968,23.852,23.852,0,0,1-2.322,2.039.288.288,0,1,0,.353.456,23.921,23.921,0,0,0,2.4-2.109m5.886-2.554a2.073,2.073,0,0,0,1.707,1.008c2.073,0,2.411-1.626,2.879-3.876.049-.238.1-.484.156-.738a9.751,9.751,0,0,1,1.06-3.2.288.288,0,0,0-.457-.352A9.619,9.619,0,0,0,14.34,9.355c-.056.256-.107.5-.157.743-.492,2.369-.775,3.417-2.311,3.417a1.557,1.557,0,0,1-1.237-.759c-.823-1.188-1.159-3.723-.207-6.268a41.129,41.129,0,0,1,2.2-4.823.288.288,0,0,0-.5-.279,41.79,41.79,0,0,0-2.235,4.9c-.9,2.41-.787,5.269.273,6.8m.854-1.026a1.043,1.043,0,0,0,.766.541c.064.006.125.009.183.009,1.007,0,1.187-.926,1.474-2.406.121-.623.271-1.4.511-2.3a12.368,12.368,0,0,1,1.356-3.033.288.288,0,0,0-.485-.313,12.733,12.733,0,0,0-1.428,3.2c-.245.92-.4,1.706-.52,2.337-.318,1.643-.443,1.991-1.035,1.932a.537.537,0,0,1-.338-.28,6.371,6.371,0,0,1-.025-4.734A25.994,25.994,0,0,1,13.485,2.47a.288.288,0,0,0-.495-.3,26.049,26.049,0,0,0-2.063,4.654,6.848,6.848,0,0,0,.088,5.231m.695-1.485a.288.288,0,0,0,.283.294H12a.288.288,0,0,0,.288-.283,16.665,16.665,0,0,1,.641-3.776,16.528,16.528,0,0,1,1.54-3.2.288.288,0,0,0-.49-.3,16.763,16.763,0,0,0-1.605,3.347,16.911,16.911,0,0,0-.663,3.922M.564,13.913a11.236,11.236,0,0,0,1.729-2.158l.126-.2c.977-1.525,3.266-5.1,6.064-3.317a.288.288,0,1,0,.309-.487,3.436,3.436,0,0,0-4.328.406,12.889,12.889,0,0,0-2.531,3.086l-.124.194A10.934,10.934,0,0,1,.18,13.482a.288.288,0,0,0,.383.431m14.516-1.57a3.193,3.193,0,0,1-3.338,2.5,2.206,2.206,0,0,1-2.024-1.461.288.288,0,0,0-.561.134,2.756,2.756,0,0,0,2.51,1.9,3.517,3.517,0,0,0,.454.03,3.841,3.841,0,0,0,3.511-2.935,11.971,11.971,0,0,0,.307-1.753,6.173,6.173,0,0,1,.81-2.9.288.288,0,0,0-.437-.376,6.363,6.363,0,0,0-.945,3.2,11.618,11.618,0,0,1-.288,1.664m-14.6-.908A14.1,14.1,0,0,0,1.62,10.1C2,9.617,2.439,9.071,2.855,8.6a.288.288,0,0,0-.433-.382C2,8.7,1.557,9.252,1.17,9.738A14.462,14.462,0,0,1,.1,11.007a.288.288,0,1,0,.386.429M5.37,5.926a4.282,4.282,0,0,0-1.943,1.2.288.288,0,1,0,.44.373A3.787,3.787,0,0,1,5.557,6.472a3.381,3.381,0,0,1,2.917.2A.288.288,0,0,0,8.8,6.2,3.948,3.948,0,0,0,5.37,5.926M.36,8.383a.288.288,0,0,0,.405-.046C.789,8.307,3.132,5.391,5.52,4.914a4.208,4.208,0,0,1,3.631.593A.288.288,0,0,0,9.558,5.1a4.711,4.711,0,0,0-4.152-.75C2.815,4.867.415,7.851.314,7.977a.288.288,0,0,0,.046.405M1.677,5.2A.288.288,0,0,0,1.89,5.1,5.365,5.365,0,0,1,3.831,3.894a.288.288,0,1,0-.2-.54,5.888,5.888,0,0,0-2.165,1.36.288.288,0,0,0,.213.482m8.5-.98a.288.288,0,0,0-.058-.4,5.969,5.969,0,0,0-5.377-.908l-.071.019a.288.288,0,1,0,.14.559l.084-.023a5.411,5.411,0,0,1,4.877.813.288.288,0,0,0,.4-.058M3.858,2.436a6.753,6.753,0,0,1,6.585.581.288.288,0,0,0,.342-.465A7.211,7.211,0,0,0,3.6,1.919a.288.288,0,0,0,.257.516M6.882.634c.026,0,2.6-.4,4.033,1.012a.288.288,0,1,0,.405-.41C9.684-.38,6.907.046,6.79.065a.288.288,0,1,0,.092.569M9.117,14.805a.288.288,0,0,0-.534.217,3.172,3.172,0,0,0,1.382,1.359.288.288,0,1,0,.291-.5,2.72,2.72,0,0,1-1.138-1.078m7.674-3.761c0,.364-.6,3.315-2.072,4.439a3.875,3.875,0,0,1-3.487.784.288.288,0,0,0-.2.54,3.281,3.281,0,0,0,1.12.178,4.8,4.8,0,0,0,2.92-1.045c1.717-1.315,2.359-4.619,2.291-4.983a.288.288,0,0,0-.57.087m-.39,5.437a.288.288,0,0,0-.4.074c-.808,1.175-3.126,1.737-5.062,1.228a4.317,4.317,0,0,1-2.5-1.613.288.288,0,1,0-.516.258,4.871,4.871,0,0,0,2.871,1.913,6.526,6.526,0,0,0,1.643.2,4.93,4.93,0,0,0,4.041-1.66.288.288,0,0,0-.074-.4M7.268,17a.288.288,0,0,0-.181.365,3.841,3.841,0,0,0,1.032,1.46,5.225,5.225,0,0,0,3.638,1.255q.227,0,.468-.014a.288.288,0,0,0-.033-.576c-3.641.213-4.522-2.207-4.558-2.311A.288.288,0,0,0,7.268,17m7.776,1.682a2.645,2.645,0,0,1-1.4.515h-.008a.288.288,0,0,0-.008.577h.016a3.191,3.191,0,0,0,1.731-.619.288.288,0,1,0-.331-.472M13.8,20.776a6.846,6.846,0,0,1-4.149-.03,5.054,5.054,0,0,1-3.137-2.422.288.288,0,0,0-.528.232,5.526,5.526,0,0,0,3.5,2.742,8.235,8.235,0,0,0,2.369.355,6.205,6.205,0,0,0,2.16-.342.288.288,0,0,0-.215-.535M5.026,19.422a.288.288,0,0,0-.126.388,4.784,4.784,0,0,0,1.356,1.6.288.288,0,1,0,.32-.48,4.259,4.259,0,0,1-1.162-1.381.288.288,0,0,0-.388-.125m6.149,3.139a4.651,4.651,0,0,1-3.792-1.085.288.288,0,0,0-.423.393,5,5,0,0,0,3.6,1.3c.212,0,.433-.01.664-.031a.288.288,0,0,0-.053-.574M7,23.038a4.449,4.449,0,0,1-2.614-2.316.288.288,0,0,0-.548.179,4.909,4.909,0,0,0,2.944,2.671A.288.288,0,0,0,7,23.038",
    transform: "translate(0 0)",
    fill: "#0f1824"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14577",
    "data-name": "Grupo 14577",
    transform: "translate(55.026 10.097)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14576",
    "data-name": "Grupo 14576",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14338",
    "data-name": "Caminho 14338",
    d: "M33.554,28.4A10.558,10.558,0,1,1,23,17.843,10.557,10.557,0,0,1,33.554,28.4",
    transform: "translate(-12.439 -17.843)",
    fill: "#1a262e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14339",
    "data-name": "Caminho 14339",
    d: "M32.127,34.971l.522,1.183,1.286-.14-.764,1.043.764,1.043-1.286-.139-.522,1.183-.522-1.183L30.32,38.1l.764-1.043-.764-1.043,1.286.14Z",
    transform: "translate(-21.569 -26.589)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14340",
    "data-name": "Caminho 14340",
    d: "M33.854,36.947l-2.594-.282-1.053,2.387-1.053-2.387-2.594.282L28.1,34.842l-1.541-2.105,2.594.282,1.053-2.388,1.053,2.388,2.594-.282-1.541,2.105Z",
    transform: "translate(-19.65 -24.373)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14341",
    "data-name": "Caminho 14341",
    d: "M33.774,35.793l-3.9-.424L28.288,38.96,26.7,35.369l-3.9.424,2.319-3.167L22.8,29.458l3.9.425,1.584-3.592,1.584,3.592,3.9-.425-2.319,3.168Z",
    transform: "translate(-17.731 -22.157)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14342",
    "data-name": "Caminho 14342",
    d: "M33.694,34.639l-5.211-.567-2.115,4.8-2.115-4.8-5.211.567,3.1-4.229-3.1-4.23,5.211.567,2.115-4.8,2.115,4.8,5.211-.567-3.1,4.23Z",
    transform: "translate(-15.811 -19.941)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14343",
    "data-name": "Caminho 14343",
    d: "M33.615,33.485,27.1,32.776l-2.646,6-2.646-6-6.519.709,3.873-5.292L15.285,22.9l6.519.709,2.646-6,2.646,6,6.519-.709-3.873,5.291Z",
    transform: "translate(-13.892 -17.725)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14344",
    "data-name": "Caminho 14344",
    d: "M33.534,32.33l-7.828-.851-3.177,7.2-3.177-7.2-7.828.851,4.651-6.353-4.651-6.354,7.828.851,3.177-7.2,3.177,7.2,7.828-.851-4.651,6.354Z",
    transform: "translate(-11.973 -15.508)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14345",
    "data-name": "Caminho 14345",
    d: "M33.455,31.176l-9.136-.993-3.707,8.409L16.9,30.183l-9.136.993L13.2,23.761,7.768,16.346l9.136.993L20.611,8.93l3.707,8.409,9.136-.993-5.428,7.415Z",
    transform: "translate(-10.054 -13.292)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14346",
    "data-name": "Caminho 14346",
    d: "M33.375,30.022,22.93,28.886,18.691,38.5l-4.238-9.613L4.008,30.022l6.206-8.477L4.008,13.068,14.453,14.2,18.691,4.59,22.93,14.2l10.444-1.135-6.206,8.477Z",
    transform: "translate(-8.134 -11.076)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14347",
    "data-name": "Caminho 14347",
    d: "M16.773.25l4.769,10.817L33.3,9.789l-6.983,9.539L33.3,28.868,21.542,27.59,16.773,38.407,12,27.59.25,28.868l6.983-9.539L.25,9.789,12,11.067Z",
    transform: "translate(-6.215 -8.86)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_8058-3",
    "data-name": "Ret\\xE2ngulo 8058",
    transform: "translate(0.111 0.06)",
    fill: "none",
    stroke: "#ebebed",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80.85,
    height: 107.8,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79.85,
    height: 106.8,
    rx: 3.5,
    fill: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlustraDocumento);
export default __webpack_public_path__ + "static/media/ilustra-documento.e7684a35b53f7753ea918a3fc1f66549.svg";
export { ForwardRef as ReactComponent };